import React from "react";
import { Pinwheel } from "ldrs/react";
import "ldrs/react/Pinwheel.css";
import { Box } from "@mui/material";
import { darkTheme, defaultTheme } from "../contexts/colorContext";

export const PinwheelLoader = () => {
  // User context and theme context are not always available where the loader is used
  const darkmode = localStorage.getItem("darkmode");
  const theme = darkmode === "true" ? darkTheme : defaultTheme;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        bgcolor: theme.palette.background.default,
      }}
    >
      <Pinwheel
        size="150"
        stroke="5"
        speed="1.5"
        color={theme.palette.primary.contrastText}
      />
    </Box>
  );
};
